/**
 * @description create video model
 * @date 2019-04-08
 * @author jywang
 */
import React, { PureComponent } from 'react';
import Upload from './component/Upload';
import UploadInfo from './component/UploadInfo';
import { observer } from 'mobx-react/custom';
import { inject } from 'mobx-react';
import { WithBaiduMediaUpload } from '../../components/HOC/BaiduMediaUpload';
import Arr from '@util/array';
import tool from '@util/tool';
import toast from '@util/toast';
import './index.scss';

let currentEditPicId: any;
@inject('store')
@WithBaiduMediaUpload(inject('store'))
@observer
class CreateVideo extends React.Component<any, any> {
    public $inputFile: HTMLInputElement;
    public proTimer: any;
    constructor(props) {
        super(props);
        const id = tool.getQueryString('id');
        if (id) {
            currentEditPicId = id;
            this.getDetail(id);
        }
    }
    public render() {
        const { store, errorStatus, getStsUpload , getStsWrite} = this.props;
        const { createVideoState } = store;
        return (
            <div className="create-video-box">
                {!errorStatus ||
                (createVideoState.uploadStatus &&
                    createVideoState.uploadStatus !== 'error') ? (
                    <UploadInfo
                        coverUpload={this.coverUpload}
                        fileInput={this.$inputFile}
                        getStsWrite={getStsWrite}
                    />
                ) : (
                    <Upload
                        fileInput={this.$inputFile}
                        getStsUpload={getStsUpload}
                    />
                )}
                <input
                    className="uploadVideoInput"
                    onChange={this.UploadVideo}
                    ref={ref => (this.$inputFile = ref)}
                    type="file"
                    name=""
                    id=""
                    multiple={false}
                    accept="video/*"
                    value=""
                />
            </div>
        );
    }
    public getDetail = id => {
        const { store } = this.props;
        this.props.store.getDetail
            .get(id)
            .then(res => {
                if (res.group.groupId) {
                    store.createVideoState.set_groupId(`${res.group.groupId}`);
                }
                store.createVideoState.set_uploadStatus('done');
                store.createVideoState.set_progress(100);
                //  store.createVideoState.set_videoSize(-1);

                store.createVideoState.set_video(res.videoUrlHigh);
                store.createVideoState.set_videoCover(res.surfacePlot);

                store.createVideoState.set_pixel(res.pixel);
                store.createVideoState.set_duration(res.playTime);
                store.createVideoState.set_videoId(res.videoId);
                store.createVideoState.set_videoDesc(res.description);
                store.createVideoState.keyValueChange('title', res.title);
            })
            .catch(err => {
                console.log('获取详情失败====>', err);
            });
    };
    public coverUpload = e => {
        const files = e.target.files;
        const { store } = this.props;
        Arr.arrForEach(files, file => {
            if (/\.(jpg|jpeg|png)$/i.test(file.name) === false) {
                toast.error('图片验证未通过:不支持该格式');
                return;
            } else if (file.size / 1024 / 1024 > 5) {
                toast.error('上传图片不能超过5M');
                return;
            }
            this.props.getStsWrite(file, data => {
                const url = data.url;
                if (url) {
                    console.log(url);
                    store.createVideoState.set_videoCover(url);
                } else {
                    toast.error('视频上传失败');
                    store.createVideoState.set_uploadStatus('error');
                }
            });
        });
    };
    public async setInfo(file, cover) {
        const { store } = this.props;
        const {frames, info} = await tool.getFrame(file);
        store.createVideoState.keyValueChange('frames', frames);
        const duration = tool.secondToDate(info.duration);
        store.createVideoState.set_pixel(`${info.videoWidth}*${info.videoHeight}`);
        store.createVideoState.set_duration(duration);
       //  setTimeout(() => {
       //  store.createVideoState.keyValueChange('frames', [...frames]);
       // }, 1000);
    }
    public UploadVideo = e => {
        const files = e.target.files;
        const size = files[0].size;
        const name = files[0].name;
        const localPath = e.target.value;
        const { store } = this.props;
        if (
            store.createVideoState.localPath &&
            store.createVideoState.localPath === localPath
        ) {
            toast.error('与原视频相同，请选择其他视频');
            return;
        }
        store.createVideoState.set_uploadStatus('pending');
        store.createVideoState.set_videoSize(size);
        store.createVideoState.set_videoName(name);
        store.createVideoState.set_localPath(localPath);
        Arr.arrForEach(files, (file) => {
            this.setInfo(file, null);
            this.props.getStsUpload(file, (data) => {
                const url = data.body.playableUrlList[0].url;
                if (url) {
                    const cover = data.body.thumbnailList[0];
                    const videoId = data.body.mediaId;
                    store.createVideoState.set_uploadStatus('done');
                    store.createVideoState.set_video(url);
                    store.createVideoState.set_videoId(videoId);
                } else {
                    toast.error('视频上传失败');
                    if (!store.createVideoState.video) {
                        store.createVideoState.set_uploadStatus('error');
                    }
                }
            }, 'new');
        });
    };
    public progressTimer = () => {
        const { store } = this.props;
        let count = 2;
        this.proTimer = setInterval(() => {
            console.log(store.createVideoState.uploadStatus);
            if (store.createVideoState.uploadStatus === 'done') {
                console.log('done=============>');
                count = 100;
                store.createVideoState.set_progress(count);
                clearInterval(this.proTimer);
            } else if (store.createVideoState.uploadStatus !== 'pending') {
                console.log('pending=======>');
                clearInterval(this.proTimer);
            } else {
                if (this.props.errorStatus) {
                    console.log('errorStatuserrorStatuserrorStatus=>出错');
                    toast.error('上传出错请重新上传');
                    store.createVideoState.set_localPath(null);
                    clearInterval(this.proTimer);
                    if (store.createVideoState.video) {
                        count = 100;
                        store.createVideoState.set_progress(count);
                    } else {
                        store.createVideoState.set_uploadStatus('error');
                    }
                } else {
                    if (count > 95) {
                        // count = count + 1 / count;
                        // store.createVideoState.set_progress(count);
                    } else {
                        count = count + 2;
                        store.createVideoState.set_progress(count);
                        // console.log(count);
                    }
                }
            }
        }, 200);
    };
}
export default CreateVideo;
